export enum ReportingMutationType {
  SET_LOADING = 'SET_LOADING',
  SET_POWER_BI_ACCESS_DETAILS = 'SET_POWER_BI_ACCESS_DETAILS'
}
